// src/config/AppShellNav.js

// 左側選單定義全部集中在這裡
// 之後要增減選項就改這裡就好
export const appShellNavItems = [
  {
    key: 'promo',
    i18nKey: 'nav.promo',
    routeName: 'PromoList',
    // 判斷 active 用的 path 前綴
    activePrefixes: ['/app/promo'],
    // 需要身份驗證 → 用來丟給 ensureVerifiedOrPrompt
    gatedReason: 'promo',
    // 這個選單需不需要顯示（這裡用 hasActivePromo）
    // ctx 會是 AppShell 的 this
    show: (ctx) => ctx.hasActivePromo === true,
  },
  {
    key: 'products',
    i18nKey: 'nav.products',
    routeName: 'AppProducts',
    activePrefixes: ['/app/products', '/app/product/'],
    gatedReason: 'products',
  },
  {
    key: 'papers',
    i18nKey: 'nav.papers',
    routeName: 'AppPapers',
    activePrefixes: ['/app/papers', '/app/paper/'],
    gatedReason: 'papers',
  },
  {
    key: 'videos',
    i18nKey: 'nav.videos',
    routeName: 'VideoIndex',
    activePrefixes: ['/app/videos', '/app/video/'],
    gatedReason: 'video',
  },
  {
    key: 'share',
    i18nKey: 'nav.shares',
    routeName: 'AppShare',
    activePrefixes: ['/app/share'],
    gatedReason: 'share',
  },
  {
    key: 'download',
    i18nKey: 'nav.downloads',
    routeName: 'AppDownload',
    activePrefixes: ['/app/download'],
    gatedReason: 'download',
  },
  {
    key: 'trial',
    i18nKey: 'nav.trial',          // 之後去 i18n 裡加這個字串
    routeName: 'AppTrial',         // 新頁面的 route name
    activePrefixes: ['/app/trial'],
    gatedReason: 'trial',          // 也可用 'products' / 'download' 之類，看你要怎麼分
  },
  {
    key: 'profile',
    i18nKey: 'nav.profile',
    routeName: 'AppProfile',
    activePrefixes: ['/app/profile'],
    gatedReason: null, // 不需要驗證
  },
  {
    key: 'contact',
    i18nKey: 'nav.contact',
    routeName: 'AppContact',
    activePrefixes: ['/app/contact'],
    gatedReason: null, // 聯絡我們通常不該被擋
  },

]
